import { Component } from '@angular/core';

@Component({
  selector: 'app-plus-icon',
  templateUrl: './plus-icon.component.html',
  styleUrl: './plus-icon.component.scss',
})
export class PlusIconComponent {}
